<template>
  <div class="infoscreen-container">
    <TicketGreedNew
      v-if="tempTicket"
      ref="tempTicket"
      :class="[showTempTicket ? 'show' : 'hide']"
      :ticket="tempTicket"
    />
    <div
      v-for="(item, index) in currentItems"
      :key="item ? item.id : -(index + 1)"
      class="infoscreen-item"
      :style="{ backgroundColor: $store.infoscreenData.infoboardBackgroundColor }"
    >
      <TicketGreedNew v-if="item" ref="ticketRef" :ticket="item" />
    </div>
  </div>
</template>

<script>
import TicketGreedNew from '../tickets/TicketGreedNew';
import TemplateMixin from '../../mixins/TemplateMixin';

export default {
  name: 'TemplateGreedNew',
  components: {
    TicketGreedNew,
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(6);
    },
  },
};
</script>

<style lang="scss" scoped>
.infoscreen-container {
  --ticket-gap: 2px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: var(--ticket-gap);
  height: 100%;
}

.infoscreen-item {
  border-radius: 20px;
  overflow: hidden;
}

.infoscreen-item > * {
  height: 100%;
  width: 100%;
}

.show {
  display: flex;
}

.hide {
  display: none;
}
</style>

